// This import loads the firebase namespace along with all its type information.
import MetricDeployment from './metric-deployment-model'

export async function load_metricDeployments(): Promise<MetricDeployment[]> {
  throw 'Not implemented'
}

export async function delete_metricDeployment(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_metricDeployment(): Promise<MetricDeployment> {
  throw 'Not implemented'
}
